import React from 'react';
import PropTypes from 'prop-types';
import { isEqual, isEmpty, map } from 'lodash';
import { Alert, Button, Col, ButtonGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

import AnnotationTemplatePreview from '../../AnnotationTemplatePreview';

const AnnotationsMapsEditTemplate = props => {
  const {
    annotationTemplates,
    handleSelectedTemplateChange,
    selectedTemplate,
    updateAnnotationFields,
    isNotesComponent,
    ...rest
  } = props;

  return (
    <>
      <Col xs={12} className="px-0 overflow-auto">
        <ButtonGroup size="sm">
          {map(annotationTemplates, (template, index) => {
            const buttonStyle = isEqual(templateOps.getId(template), selectedTemplate)
              ? 'success'
              : 'light';
            return (
              <Button
                key={`${templateOps.getName(template)}-${index}`}
                variant={buttonStyle}
                onClick={() => handleSelectedTemplateChange(template)}
              >
                <FontAwesomeIcon icon={templateOps.getIcon(template)} size="lg" />
              </Button>
            );
          })}
        </ButtonGroup>
      </Col>
      <Col xs={12}>
        {isEmpty(selectedTemplate) ? (
          <Alert variant="info">No template selected</Alert>
        ) : (
          <AnnotationTemplatePreview
            annotationTemplate={selectedTemplate}
            previewMode="edition"
            updateAnnotationFields={updateAnnotationFields}
            isNotesComponent={isNotesComponent}
            {...rest}
          />
        )}
      </Col>
    </>
  );
};
AnnotationsMapsEditTemplate.defaultProps = {
  isNotesComponent: false
};

AnnotationsMapsEditTemplate.propTypes = {
  annotationTemplates: PropTypes.array.isRequired,
  handleSelectedTemplateChange: PropTypes.func.isRequired,
  selectedTemplate: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func.isRequired,
  isNotesComponent: PropTypes.bool
};

export default AnnotationsMapsEditTemplate;
